const user_identity_details = {
    social_identity_page_title: 'تفاصيل الهوية الاجتماعية',
    back_to_user_details: 'العودة إلى تفاصيل المستخدم',
    delete_identity: `إزالة اتصال الهوية`,
    social_account: {
        title: 'حساب اجتماعي',
        description: 'عرض بيانات المستخدم ومعلومات الملف الشخصي المتزامنة من حساب {{connectorName}} المتصل.',
        provider_name: 'اسم موفر الهوية الاجتماعية',
        identity_id: 'معرف الهوية الاجتماعية',
        user_profile: 'الملف الشخصي للمستخدم المتزامن من موفر الهوية الاجتماعية',
    },
    sso_account: {
        title: 'حساب SSO للمؤسسة',
        description: 'عرض بيانات المستخدم ومعلومات الملف الشخصي المتزامنة من حساب {{connectorName}} المتصل.',
        provider_name: 'اسم موفر هوية SSO للمؤسسة',
        identity_id: 'معرف هوية SSO للمؤسسة',
        user_profile: 'الملف الشخصي للمستخدم المتزامن من موفر هوية SSO للمؤسسة',
    },
    token_storage: {
        title: 'رمز الوصول',
        description: 'تخزين الرموز المميزة للوصول والتحديث من {{connectorName}} في الخزنة السرية. يسمح بإجراء مكالمات API تلقائية دون الحاجة إلى موافقة متكررة من المستخدم.',
    },
    access_token: {
        title: 'رمز الوصول',
        description_active: 'رمز الوصول نشط ومخزن بأمان في الخزنة السرية. يمكن للمنتج الخاص بك استخدامه للوصول إلى واجهات برمجة التطبيقات من {{connectorName}}.',
        description_inactive: 'رمز الوصول هذا غير نشط (مثلاً، تم إلغاؤه). يجب على المستخدمين إعادة التفويض لاستعادة الوظائف.',
        description_expired: 'رمز الوصول هذا قد انتهت صلاحيته. يتم التجديد تلقائياً عند الطلب التالي لواجهة برمجة التطبيقات باستخدام رمز التحديث. إذا لم يكن رمز التحديث متاحاً، يتطلب إعادة مصادقة المستخدم.',
    },
    refresh_token: {
        available: 'رمز التحديث متاح. إذا انتهت صلاحية رمز الوصول، سيتم تجديده تلقائياً باستخدام رمز التحديث.',
        not_available: 'رمز التحديث غير متاح. بعد انتهاء صلاحية رمز الوصول، يجب على المستخدمين إعادة المصادقة للحصول على رموز جديدة.',
    },
    token_status: 'حالة الرمز المميز',
    created_at: 'تاريخ الإنشاء',
    updated_at: 'تاريخ التحديث',
    expires_at: 'تاريخ الانتهاء',
    scopes: 'النطاقات',
    delete_tokens: {
        title: 'حذف الرموز المميزة',
        description: 'حذف الرموز المميزة المخزنة. يجب على المستخدمين إعادة التفويض لاستعادة الوظائف.',
        confirmation_message: 'هل أنت متأكد من أنك تريد حذف الرموز المميزة؟ سيقوم Logto Secret Vault بإزالة رموز الوصول والتحديث المخزنة لـ {{connectorName}}. يجب على هذا المستخدم إعادة التفويض لاستعادة الوصول إلى واجهات برمجة التطبيقات لـ {{connectorName}}.',
    },
    token_storage_disabled: {
        title: 'تم تعطيل تخزين الرموز المميزة لهذا الموصل',
        description: 'يمكن للمستخدمين حالياً استخدام {{connectorName}} فقط لتسجيل الدخول، وربط الحسابات، أو مزامنة الملفات الشخصية خلال كل تدفق موافقة. للوصول إلى واجهات برمجة التطبيقات لـ {{connectorName}} وتنفيذ الإجراءات نيابة عن المستخدمين، يرجى تمكين تخزين الرموز المميزة في',
    },
};
export default Object.freeze(user_identity_details);
